import { Directive, Input } from '@angular/core';

@Directive({ standalone: true })
export abstract class BaseCard<T> {
  @Input() item: T;
  @Input() titleExpression = 'name';
  @Input() summaryExpression = 'description';
  @Input() imageExpression = 'imageUrl';
}
